module.exports = __webpack_public_path__ + "media/images/emblems/Grandfontaine-coat_of_arms-98c77d12de3174d53ddbb406e525cebc.svg";